import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthAppService } from './auth-app/auth-app.service';

@Injectable({
  providedIn: 'root'
})
export class WellbeingGuard implements CanActivate {
  constructor(private auth: AuthAppService) {}
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.getSavedUser()?.is_wellbeing_owner) {
      return true;
    }
    return false;
  }
}
